'use strict';

var _objectSpread = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _toConsumableArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var multiaddr = require('multiaddr');

var errCode = require('err-code');

var TimeoutController = require('timeout-abort-controller');

var anySignal = require('any-signal');

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

var debug = require('debug');

var log = debug('libp2p:dialer');
log.error = debug('libp2p:dialer:error');

var _require = require('./dial-request'),
    DialRequest = _require.DialRequest;

var _require2 = require('../errors'),
    codes = _require2.codes;

var _require3 = require('../constants'),
    DIAL_TIMEOUT = _require3.DIAL_TIMEOUT,
    MAX_PARALLEL_DIALS = _require3.MAX_PARALLEL_DIALS,
    MAX_PER_PEER_DIALS = _require3.MAX_PER_PEER_DIALS;

var Dialer = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {object} options
   * @param {TransportManager} options.transportManager
   * @param {Peerstore} peerStore
   * @param {number} options.concurrency Number of max concurrent dials. Defaults to `MAX_PARALLEL_DIALS`
   * @param {number} options.timeout How long a dial attempt is allowed to take. Defaults to `DIAL_TIMEOUT`
   */
  function Dialer(_ref) {
    var transportManager = _ref.transportManager,
        peerStore = _ref.peerStore,
        _ref$concurrency = _ref.concurrency,
        concurrency = _ref$concurrency === void 0 ? MAX_PARALLEL_DIALS : _ref$concurrency,
        _ref$timeout = _ref.timeout,
        timeout = _ref$timeout === void 0 ? DIAL_TIMEOUT : _ref$timeout,
        _ref$perPeerLimit = _ref.perPeerLimit,
        perPeerLimit = _ref$perPeerLimit === void 0 ? MAX_PER_PEER_DIALS : _ref$perPeerLimit;

    _classCallCheck(this, Dialer);

    this.transportManager = transportManager;
    this.peerStore = peerStore;
    this.concurrency = concurrency;
    this.timeout = timeout;
    this.perPeerLimit = perPeerLimit;
    this.tokens = _toConsumableArray(new Array(concurrency)).map(function (_, index) {
      return index;
    });
    this._pendingDials = new Map();
  }
  /**
   * Clears any pending dials
   */


  _createClass(Dialer, [{
    key: "destroy",
    value: function destroy() {
      var _iterator = _createForOfIteratorHelper(this._pendingDials.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var dial = _step.value;

          try {
            dial.controller.abort();
          } catch (err) {
            log.error(err);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._pendingDials.clear();
    }
    /**
     * Connects to a given `PeerId` or `Multiaddr` by dialing all of its known addresses.
     * The dial to the first address that is successfully able to upgrade a connection
     * will be used.
     *
     * @param {PeerInfo|Multiaddr} peer The peer to dial
     * @param {object} [options]
     * @param {AbortSignal} [options.signal] An AbortController signal
     * @returns {Promise<Connection>}
     */

  }, {
    key: "connectToPeer",
    value: function () {
      var _connectToPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peer) {
        var options,
            dialTarget,
            pendingDial,
            connection,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                dialTarget = this._createDialTarget(peer);

                if (!(dialTarget.addrs.length === 0)) {
                  _context.next = 4;
                  break;
                }

                throw errCode(new Error('The dial request has no addresses'), codes.ERR_NO_VALID_ADDRESSES);

              case 4:
                pendingDial = this._pendingDials.get(dialTarget.id) || this._createPendingDial(dialTarget, options);
                _context.prev = 5;
                _context.next = 8;
                return pendingDial.promise;

              case 8:
                connection = _context.sent;
                log('dial succeeded to %s', dialTarget.id);
                return _context.abrupt("return", connection);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](5);

                // Error is a timeout
                if (pendingDial.controller.signal.aborted) {
                  _context.t0.code = codes.ERR_TIMEOUT;
                }

                log.error(_context.t0);
                throw _context.t0;

              case 18:
                _context.prev = 18;
                pendingDial.destroy();
                return _context.finish(18);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 13, 18, 21]]);
      }));

      function connectToPeer(_x) {
        return _connectToPeer.apply(this, arguments);
      }

      return connectToPeer;
    }()
    /**
     * @typedef DialTarget
     * @property {string} id
     * @property {Multiaddr[]} addrs
     */

    /**
     * Creates a DialTarget. The DialTarget is used to create and track
     * the DialRequest to a given peer.
     * @private
     * @param {PeerInfo|Multiaddr} peer A PeerId or Multiaddr
     * @returns {DialTarget}
     */

  }, {
    key: "_createDialTarget",
    value: function _createDialTarget(peer) {
      var dialable = Dialer.getDialable(peer);

      if (multiaddr.isMultiaddr(dialable)) {
        return {
          id: dialable.toString(),
          addrs: [dialable]
        };
      }

      var addrs = this.peerStore.multiaddrsForPeer(dialable);
      return {
        id: dialable.id.toB58String(),
        addrs: addrs
      };
    }
    /**
     * @typedef PendingDial
     * @property {DialRequest} dialRequest
     * @property {TimeoutController} controller
     * @property {Promise} promise
     * @property {function():void} destroy
     */

    /**
     * Creates a PendingDial that wraps the underlying DialRequest
     * @private
     * @param {DialTarget} dialTarget
     * @param {object} [options]
     * @param {AbortSignal} [options.signal] An AbortController signal
     * @returns {PendingDial}
     */

  }, {
    key: "_createPendingDial",
    value: function _createPendingDial(dialTarget, options) {
      var _this = this;

      var dialAction = function dialAction(addr, options) {
        if (options.signal.aborted) throw errCode(new Error('already aborted'), codes.ERR_ALREADY_ABORTED);
        return _this.transportManager.dial(addr, options);
      };

      var dialRequest = new DialRequest({
        addrs: dialTarget.addrs,
        dialAction: dialAction,
        dialer: this
      }); // Combine the timeout signal and options.signal, if provided

      var timeoutController = new TimeoutController(this.timeout);
      var signals = [timeoutController.signal];
      options.signal && signals.push(options.signal);
      var signal = anySignal(signals);
      var pendingDial = {
        dialRequest: dialRequest,
        controller: timeoutController,
        promise: dialRequest.run(_objectSpread(_objectSpread({}, options), {}, {
          signal: signal
        })),
        destroy: function destroy() {
          timeoutController.clear();

          _this._pendingDials.delete(dialTarget.id);
        }
      };

      this._pendingDials.set(dialTarget.id, pendingDial);

      return pendingDial;
    }
  }, {
    key: "getTokens",
    value: function getTokens(num) {
      var total = Math.min(num, this.perPeerLimit, this.tokens.length);
      var tokens = this.tokens.splice(0, total);
      log('%d tokens request, returning %d, %d remaining', num, total, this.tokens.length);
      return tokens;
    }
  }, {
    key: "releaseToken",
    value: function releaseToken(token) {
      // Guard against duplicate releases
      if (this.tokens.indexOf(token) > -1) return;
      log('token %d released', token);
      this.tokens.push(token);
    }
    /**
     * Converts the given `peer` into a `PeerInfo` or `Multiaddr`.
     * @static
     * @param {PeerInfo|PeerId|Multiaddr|string} peer
     * @returns {PeerInfo|Multiaddr}
     */

  }], [{
    key: "getDialable",
    value: function getDialable(peer) {
      if (PeerInfo.isPeerInfo(peer)) return peer;

      if (typeof peer === 'string') {
        peer = multiaddr(peer);
      }

      var addr;

      if (multiaddr.isMultiaddr(peer)) {
        addr = peer;

        try {
          peer = PeerId.createFromCID(peer.getPeerId());
        } catch (err) {
          throw errCode(new Error('The multiaddr did not contain a valid peer id'), codes.ERR_INVALID_PEER);
        }
      }

      if (PeerId.isPeerId(peer)) {
        peer = new PeerInfo(peer);
      }

      addr && peer.multiaddrs.add(addr);
      return peer;
    }
  }]);

  return Dialer;
}();

module.exports = Dialer;